import { TRACE_HEADERS } from '../data/app'
import { PACKAGE_VERSION } from '../data/environment'
import { ensureDeviceId } from './ensureDeviceId'

/** The app version + device id pair every request carries: the GraphQL
 * clients and the auth calls (login, refresh, switch organization) share this
 * one source. On native the first call also creates and stores the device id. */
export const getTraceIdentityHeaders = (): Record<string, string> => ({
  [TRACE_HEADERS.VERSION]: PACKAGE_VERSION,
  [TRACE_HEADERS.DEVICE_ID]: ensureDeviceId(),
})
